import * as React from 'react'
import {
  Button as FUIButton,
  ButtonProps,
  makeStyles,
  Spinner
} from '@fluentui/react-components'
import { COLORS } from '../../constants'

type CustomButtonProps = ButtonProps & {
  text: string
  loading?: boolean
}

const useStyles = makeStyles({
  root: {
    color: COLORS.white,
    backgroundColor: COLORS.primary,
    ':hover': {
      color: COLORS.white,
      backgroundColor: COLORS.secondary
    }
  },
  spinner: {
    width: '12px',
    height: '12px'
  },
  buttonContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '100px'
  },
  textHidden: {
    visibility: 'hidden'
  }
})

const Button: React.FC<CustomButtonProps> = (props) => {
  const { text, loading, disabled, ...rest } = props
  const classes = useStyles()

  return (
    <FUIButton
      className={classes.root}
      {...rest}
      disabled={loading || disabled}
    >
      <div className={classes.buttonContent}>
        {loading ? (
          <Spinner className={classes.spinner} />
        ) : (
          <span>{text}</span>
        )}
        {loading && <span className={classes.textHidden}>{text}</span>}{' '}
      </div>
    </FUIButton>
  )
}

export default Button
